import { Button, Result } from "antd";
import { FC } from "react";
import { Link } from "react-router-dom";

const NotFound: FC = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist"
      extra={
        <Link to="/">
          <Button type="primary">Home</Button>
        </Link>
      }
    />
  );
};

export default NotFound;
